const FILTER_ID_MAP = {
        NGNSZ: "displacements",
        radiusRanges: "radius",
        licenses: "driverlicenses"
      };

export function mapFilters(filters) {
  return filters
    .filter(f => f.values.length)
    .map(f => ({
      ...f,
      id: FILTER_ID_MAP[f.id] || f.id
    }));
}